import { type Common } from './common.js';
import type * as EhrTimeSlot from './models/ehrTimeSlot.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/ehr-time-slots';

  constructor(common: Common) {
    this.common = common;
  }

  async fetchAvailableTimeSlots(args: {
    previsitFormFieldId: string;
    startTime?: Date;
    endTime?: Date;
    patientOrderId?: string;
    practiceIds?: string[];
    providerIds?: string[];
    assistantId?: string;
  }): Promise<EhrTimeSlot.AvailableEhrTimeSlotResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}`, {
      ...args,
      startTime: args.startTime?.toISOString(),
      endTime: args.endTime?.toISOString(),
    });
    return await this.common.getJSON(
      url,
      undefined, // request init
      true // return error status
    );
  }

  async bookTimeSlot(args: {
    ehrTimeSlotId: string;
    previsitFormFieldId: string;
    startTime: Date;
    endTime: Date;
    appointmentKind?: EhrTimeSlot.AppointmentKind;
    patientOrderId?: string;
    practiceId: string;
    providerId?: string;
    slotType?: string;
    session?: string;
    providerName?: string;
    departmentName?: string;
    location?: string;
    sessionStartTime?: string;
    comment?: string;
    assistantId?: string;
  }): Promise<EhrTimeSlot.TimeSlotConfirmation> {
    const {
      ehrTimeSlotId,
      previsitFormFieldId,
      startTime,
      endTime,
      appointmentKind,
      patientOrderId,
      practiceId,
      providerId,
      slotType,
      session,
      providerName,
      departmentName,
      location,
      sessionStartTime,
      comment,
      assistantId,
    } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    const { confirmationInformation } = await this.common.postJSON(
      url,
      {
        ehrTimeSlotId,
        previsitFormFieldId,
        startTime,
        endTime,
        appointmentKind,
        practiceId,
        providerId,
        slotType,
        session,
        providerName,
        departmentName,
        location,
        sessionStartTime,
        comment,
        assistantId,
        patientOrderId,
      },
      'POST', // http method
      undefined, // request init
      true // return error status
    );
    return confirmationInformation;
  }
}
